import { UserSettingLanguage } from "@/components/user-settings/user-setting-language";

export default function SettingsLanguagePage() {
  return (
    <>
      <UserSettingLanguage />
    </>
  );
}
